import { ClusterProduct } from "./cluster-product.model";

export class ClusterProductPageableResult {
  private start: number;
  private totalPerPages: number;
  private total: number;
  private data: Array<ClusterProduct>;

  public getStart(): number {
    return this.start;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public getTotal(): number {
    return this.total;
  }

  public getData(): Array<ClusterProduct> {
    return this.data;
  }

  public setStart(value: number) {
    this.start = value;
  }

  public setTotalPerPages(value: number) {
    this.totalPerPages = value;
  }

  public setTotal(value: number) {
    this.total = value;
  }

  public setData(value: Array<ClusterProduct>) {
    this.data = value;
  }
}
